module.exports = __webpack_public_path__ + "static/media/flag-eu.931ca9bc.svg";